var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17V15H2V8C2 6.61667 2.41667 5.38767 3.25 4.313C4.08333 3.23833 5.16667 2.534 6.5 2.2V1.5C6.5 1.08333 6.646 0.729333 6.938 0.438C7.23 0.146667 7.584 0.000666667 8 0C8.41667 0 8.771 0.146 9.063 0.438C9.355 0.73 9.50067 1.084 9.5 1.5V2.2C10.8333 2.53333 11.9167 3.23767 12.75 4.313C13.5833 5.38833 14 6.61733 14 8V15H16V17H0ZM8 20C7.45 20 6.97933 19.8043 6.588 19.413C6.19667 19.0217 6.00067 18.5507 6 18H10C10 18.55 9.80433 19.021 9.413 19.413C9.02167 19.805 8.55067 20.0007 8 20ZM4 15H12V8C12 6.9 11.6083 5.95833 10.825 5.175C10.0417 4.39167 9.1 4 8 4C6.9 4 5.95833 4.39167 5.175 5.175C4.39167 5.95833 4 6.9 4 8V15Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.eb868ab32eb03836f7561fbd19e89f11.svg";
export { ForwardRef as ReactComponent };